import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import Logo from './headerLogo.png'
import './Headers.css';
import { HomeIcon, BackIcon } from '../../Icons/Icons';
import Fade from 'react-reveal/Fade';
import IconButton from '@material-ui/core/IconButton';
import { withRouter } from 'react-router-dom';
import ReactGA from 'react-ga';

class DGRHeader extends Component {
    homePressed = (e) => {
        ReactGA.set({ dimension7: new Date().getTime() });
        ReactGA.event({
            category: 'Navigation',
            action: 'Home Button'
        });
        this.props.DGRModalStore.closeModal()
        this.props.DGRStore.clearValues()
        this.props.history.push('');
    }
    backPressed = (e) => {
        ReactGA.set({ dimension7: new Date().getTime() });
        ReactGA.event({
            category: 'Navigation',
            action: 'Back Button'
        });
        if ( window.location.href.indexOf( '/member/purchase' ) > -1 || window.location.href.indexOf( '/member/unavailable' ) > -1 ) {
            this.props.history.push('/member/menu');
        } else if ( window.location.href.indexOf( '/membership_options' ) > -1 ) {
            this.props.history.push('/join');
        } else if ( window.location.href.indexOf( '/join' ) > -1 ) {
            this.props.history.push('');
        } else {
            window.history.back();
        }
    }

    renderBackButton() {
        var sizeObj = {
            fontSize: 40
        }
        if ( ( this.props.history.length > 0 && this.props.location.pathname !== '/' ) || window.location.href.indexOf( '/member/purchase' ) > -1 ) {
            return (
                <div className="backIcon">
                    <IconButton onClick={this.backPressed} >
                        <BackIcon
                            nativeColor='#FFFFFF' className=""
                            style={sizeObj}
                            viewBox="0 0 40 40"
                        />
                    </IconButton>
                </div>
            );
        } else {
            return '';
        }
    }
 
    renderWelcomeName() {
        if ( this.props.DGRStore.values.first_name ) {
            return (
                <div className="welcomeName">
                    Welcome, { this.props.DGRStore.values.first_name }
                </div>
            );
        } else {
            return '';
        }
    }

    render(){
        var sizeObj = {
            fontSize: 40 
        }
        if (this.props.DGRBackgroundStore.showHeader){ 
        const { name, full_address } = this.props.DGRStore.clubValues
            return( 
                    <Fade>
                    <div className="dgrHeader">
                        <div className="topicons">
                            { this.renderBackButton() }
                            <div className="headerHomeIcon" onClick={ this.homePressed }>
                                <IconButton>
                                    <HomeIcon
                                        nativeColor='#FFFFFF' className=""
                                        style={sizeObj}
                                        viewBox="0 0 40 40"
                                    />
                                </IconButton>
                                <span className="logouttext">Logout</span>
                            </div>
                            { this.renderWelcomeName() }
                        </div>
                        <div><img alt='logo' className="headerLogo" src={Logo}/></div>
                        <div className="headerAddress">
                            <div className="headerAddressItem">
                                <div className="headerAddressTitle">{name}</div>
                            </div>
                            <div className="headerAddressItem">
                                <div className="headerAddressSubTitle">{full_address}</div>
                            </div>
                        </div>
                    </div>
                    </Fade>
            )
        }else{
            return(
                <div></div>
            )
        }
    }
}

DGRHeader = inject('DGRModalStore','DGRBackgroundStore', 'DGRStore' )(observer(DGRHeader))     
export default withRouter( DGRHeader );


// WEBPACK FOOTER //
// ./src/components/DGR/Header/Header.js